import Image from "@ingka/image";
import React, { MouseEventHandler } from "react";

import "@ingka/image/dist/style.css";
import "@ingka/svg-icon/dist/style.css";

type FixaImageProps = {
  src?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: MouseEventHandler<HTMLImageElement>;
  onError?: MouseEventHandler<HTMLImageElement>;
  key?: React.Key;
  id?: string;
  alt?: string;
  "data-testid"?: string;
  fallback?: boolean;
  loading?: "lazy" | "eager";
};

function FixaImage(props: FixaImageProps) {
  return <Image {...props} />;
}

export default FixaImage;
